import {
  IMAGE_MIME_TYPE,
  PDF_MIME_TYPE,
  MS_EXCEL_MIME_TYPE,
  MS_WORD_MIME_TYPE,
  MS_POWERPOINT_MIME_TYPE
} from "@mantine/dropzone";

export const acceptedUploadFileExtensions = [
  ...IMAGE_MIME_TYPE,
  ...PDF_MIME_TYPE,
  ...MS_EXCEL_MIME_TYPE,
  ...MS_WORD_MIME_TYPE,
  ...MS_POWERPOINT_MIME_TYPE,
  // csv
  "text/csv"
];
